export const EPOST_FORM_PROVIDER = 'EpostProvider.binectKey'
